"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Navigation = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DropDown = _interopRequireDefault(require("./components/DropDown"));
var _RestLinks = _interopRequireDefault(require("./components/RestLinks"));
var _TopNav = require("./TopNav.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var LinksInline = function LinksInline(_ref) {
  var activeDropDown = _ref.activeDropDown,
    closeDropDown = _ref.closeDropDown,
    handleDropDownFocus = _ref.handleDropDownFocus,
    isDark = _ref.isDark,
    links = _ref.links,
    _ref$indexOffset = _ref.indexOffset,
    indexOffset = _ref$indexOffset === void 0 ? 0 : _ref$indexOffset;
  return links.map(function (link, index) {
    var originalIndex = index + indexOffset;
    if (!link.dropdown) {
      return /*#__PURE__*/_react.default.createElement(_TopNav.NavItem, {
        key: "max-desktop-navigation__nav-item-".concat(originalIndex),
        isDark: isDark,
        "data-key": "max-desktop-navigation__nav-item-".concat(originalIndex),
        onFocus: closeDropDown,
        noDropdown: true
      }, link);
    }
    if (link.dropdown) {
      var isActive = activeDropDown === originalIndex;
      return /*#__PURE__*/_react.default.createElement(_DropDown.default, {
        link: link,
        isDark: isDark,
        index: originalIndex,
        className: isActive ? 'focus' : '',
        onFocus: function onFocus() {
          return handleDropDownFocus(originalIndex);
        },
        key: "max-top-desktop__primary-nav__nav-item-".concat(originalIndex),
        "data-key": "max-top-desktop__primary-nav__nav-item-".concat(originalIndex)
      }, link.subLinks.map(function (subLink, index) {
        return /*#__PURE__*/_react.default.createElement(_TopNav.SubNavItem, {
          key: "max-top-desktop__primary-nav__nav-item-".concat(index),
          "data-key": "max-top-desktop__primary-nav__nav-item-".concat(index)
        }, subLink);
      }));
    }
  });
};
var Navigation = /*#__PURE__*/function (_Component) {
  _inherits(Navigation, _Component);
  var _super = _createSuper(Navigation);
  function Navigation() {
    var _temp, _this;
    _classCallCheck(this, Navigation);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_temp = _this = _super.call.apply(_super, [this].concat(args)), _this.navigationRef = /*#__PURE__*/_react.default.createRef(), _this.priorityLinks = _this.props.primaryLinks.slice(0, _this.props.priorityNumber), _this.restLinks = _this.props.primaryLinks.slice(_this.props.priorityNumber), _this.componentDidMount = function () {
      document.addEventListener('mousedown', _this.handleEventOutside);
      document.addEventListener('focus', _this.handleEventOutside);
    }, _this.componentWillUnmount = function () {
      document.removeEventListener('mousedown', _this.handleEventOutside);
      document.removeEventListener('focus', _this.handleEventOutside);
    }, _this.handleEventOutside = function (event) {
      if (_this.navigationRef && !_this.navigationRef.current.contains(event.target)) {
        _this.props.closeDropDown();
      }
    }, _temp));
  }
  _createClass(Navigation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isDark = _this$props.isDark,
        handleDropDownFocus = _this$props.handleDropDownFocus,
        activeDropDown = _this$props.activeDropDown;
      var priorityLinks = this.priorityLinks,
        restLinks = this.restLinks;
      return /*#__PURE__*/_react.default.createElement(_TopNav.Column, {
        "data-key": "max-desktop-navigation__nav",
        ref: this.navigationRef
      }, /*#__PURE__*/_react.default.createElement(LinksInline, _extends({
        links: priorityLinks
      }, this.props)), /*#__PURE__*/_react.default.createElement(_TopNav.RestLinksInline, null, /*#__PURE__*/_react.default.createElement(LinksInline, _extends({
        links: restLinks,
        indexOffset: this.props.priorityNumber
      }, this.props))), restLinks.length > 0 && /*#__PURE__*/_react.default.createElement(_TopNav.RestLinksDropDown, null, /*#__PURE__*/_react.default.createElement(_RestLinks.default, {
        isDark: isDark,
        restLinks: restLinks,
        closeDropDown: this.closeDropDown,
        activeDropDown: activeDropDown,
        handleDropDownFocus: handleDropDownFocus,
        moreText: this.props.moreText
      })));
    }
  }]);
  return Navigation;
}(_react.Component);
exports.Navigation = Navigation;
var _default = Navigation;
exports.default = _default;